import { useEffect } from "react";
import usePagination from "./usePagination";
import { useQuery } from "@apollo/client";
import { IPMVStatus, IPMVStatusIndexParams } from "models/Pmv";
import { GET_PMV_STATUSES } from "graphql/queries/pmv_status";

const usePMVStatuses = ({
    page: externalPage,
    pageSize: externalPageSize,
    orderBy = "desc",
    startDate,
    endDate
}: IPMVStatusIndexParams) => {

    const hookPMVStatuses = usePagination<IPMVStatus>({
        page: externalPage,
        pageSize: externalPageSize,
        sortOrder: orderBy as "desc" | "asc"
    });

    const { page, pageSize } = hookPMVStatuses;
    const { data, loading } = useQuery(GET_PMV_STATUSES(page, pageSize, orderBy as "desc" | "asc", startDate, endDate), {
        // pollInterval: 1000*60, //Actualiza cada minuto
        fetchPolicy: 'network-only',
        nextFetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (loading) {
            hookPMVStatuses.loadingStart();
        } else {
            hookPMVStatuses.loadingEnd();
        }

        if (data) {
            const { its_pmv_statuses: dataPMVStatuses, its_pmv_statuses_aggregate } = data;
            const { count: totalItems } = its_pmv_statuses_aggregate.aggregate;
            hookPMVStatuses.setData(dataPMVStatuses);
            hookPMVStatuses.setTotalItems(totalItems);
        }
    }, [data, loading]);

    return hookPMVStatuses;
};

export default usePMVStatuses;
